import { useContext, useState } from 'react';
import moment from 'moment';
import t from 'react-translate';
import NvConfirmationPopover from 'shared/components/nv-confirmation-popover';
import NvPopover from 'shared/components/nv-popover';
import NvSwitch from 'shared/components/inputs/nv-switch';
import { NvTooltip } from 'shared/components/nv-tooltip';
import { useAppDispatch } from 'redux/store';
import { SaveStatus } from 'redux/schemas/app/mentoring-programs';
import {
  setSaveStatus,
  updateMentoringProgram,
} from 'redux/actions/mentoring-programs';
import { wrapThunkAction } from 'redux/utils';
import { config } from '@config/pendo.config.json';
import { overlayStyles } from '../program-setup/styles';
import MentoringProgramContext from '../../context';

const ExpertMentoringGuides = () => {
  const dispatch = useAppDispatch();
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { guidanceEnabled, releasedDate } = mentoringProgram || {};
  const translationBase = t.MENTORING_PROGRAMS.SETTINGS.TABS.GUIDANCE.GUIDES_ENABLED;
  const [showConfirmation, setShowConfirmation] = useState(false);

  const label = guidanceEnabled
    ? translationBase.ARIA_LABEL.TURN_GUIDANCE_OFF()
    : translationBase.ARIA_LABEL.TURN_GUIDANCE_ON();

  const handleConfirm = () => {
    dispatch(setSaveStatus({ newStatus: SaveStatus.IN_PROGRESS }));
    wrapThunkAction(
      dispatch(
        updateMentoringProgram({
          id: mentoringProgram.id,
          autoMatchingEnabled: !!mentoringProgram.autoMatchingEnabled,
          maxMentees: mentoringProgram.concurrentMentorConnection,
          guidanceEnabled: !guidanceEnabled,
        }),
      ),
    ).then(() => {
      dispatch(setSaveStatus({ newStatus: SaveStatus.COMPLETED }));
    }).finally(() => {
      setTimeout(() => {
        dispatch(setSaveStatus({ newStatus: null }));
      }, 3000);
      setShowConfirmation(false);
    });
  };

  const handleChange = () => {
    if (guidanceEnabled && moment().isAfter(releasedDate)) {
      setShowConfirmation(true);
    } else {
      handleConfirm();
    }
  };

  return (
    <div className='mb-2'>
      <div className='d-flex mb-2 align-items-center'>
        <div className='heading-5 mr-2'>{translationBase.SWITCH_LABEL()}</div>
        <NvPopover
          enabled
          show={showConfirmation}
          overlayStyles={overlayStyles}
          content={(
            <NvConfirmationPopover
              onCancel={() => setShowConfirmation(false)}
              onConfirm={handleConfirm}
              header={translationBase.WARNING.TITLE()}
              message={translationBase.WARNING.CONTENT()}
              cancelBtnText={t.FORM.CANCEL()}
              confirmBtnText={t.FORM.OK()}
            />
          )}
          placement='top'
          rootClose
          onHide={() => setShowConfirmation(false)}
          className='d-inline-flex mw-100'
          preventOverflow
        >
          <NvTooltip placement='top' preventOverflow={false} text={label}>
            <NvSwitch
              checked={guidanceEnabled}
              onChange={handleChange}
              enabledLabel={t.SHARED.ON().toUpperCase()}
              disabledLabel={t.SHARED.OFF().toUpperCase()}
              dataQa={config.pendo.athena.mentorshipProgram.settings.guidance.enabledSwitch}
              aria-label={label}
            />
          </NvTooltip>
        </NvPopover>
      </div>
      <div className='text-body black'>
        {translationBase.DESCRIPTION()}
      </div>
    </div>
  );
};

export default ExpertMentoringGuides;
